/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { RecourseForwardProps } from '@/src/app/basvuru/[page]/yonlendirme/client.page';
import { Categories, responseForwardModel } from '@/src/interfaces/recourse-type';
import {
  useCreditRecourse,
  useDobRecourse,
  usePosRecourse,
  useSmeRecourse,
  useVehicleLoanRecourse,
} from '@/src/utils/helpers/useRecourse';
import { useEffect, useState } from 'react';
import WebPageSchema from '../../schema/WebPageSchema';
import { RecourseLoader } from '../recourse-loader/recourse-loader';

import { RecourseInfoContent } from './recourse-info-content';
import { RecourseInfoImage } from './recourse-info-image';
import { RecourseRedirector } from '../../shared/recourse-redirector';

export const RecourseInfo = ({
  params,
  searchParams,
  referrerUrl,
}: RecourseForwardProps & { referrerUrl?: string }) => {
  const [recourse, setRecourse] = useState<responseForwardModel<Categories>>();
  const { creditCardRecourseForward } = useCreditRecourse({
    query: searchParams,
    referrerUrl,
  });
  const { posProductForward } = usePosRecourse({ query: searchParams, referrerUrl });
  const { smeForward } = useSmeRecourse({ query: searchParams, referrerUrl });
  const { dobForward } = useDobRecourse({ query: searchParams, referrerUrl });
  const { vehicleForward } = useVehicleLoanRecourse({ query: searchParams, referrerUrl });

  const fetchRecourseData = async () => {
    switch (params.page) {
      case 'kredi-karti': {
        let response: responseForwardModel<'kredi-karti'> | undefined = await creditCardRecourseForward();
        return response;
      }
      case 'kobi': {
        let response: responseForwardModel<'kobi'> | undefined = await smeForward();
        return response;
      }
      case 'pos-cihazlari': {
        let response: responseForwardModel<'pos-cihazlari'> | undefined = await posProductForward();
        return response;
      }
      case 'uzaktan-musteri-edinimi': {
        let response: responseForwardModel<'uzaktan-musteri-edinimi'> | undefined = await dobForward();
        return response;
      }
      case 'ticari-tasit-kredisi': {
        let response: responseForwardModel<'ticari-tasit-kredisi'> | undefined = await vehicleForward();
        return response;
      }
      // case 'tarim-kredisi': {
      //   let response: responseForwardModel<'kobi'> | undefined = await agriCulturalForward();
      //   return response;
      // }
    }
  };

  const getPage = async () => {
    const response = await fetchRecourseData();
    if (response) setRecourse(response);
    debugger;
  };

  useEffect(() => {
    getPage();
  }, []);

  return (
    <>
      <WebPageSchema seoInfo={recourse?.seoInfo} />
      {/* <RecourseRedirector bankName={recourse?.recourseForward?.bankName} forwardLink={recourse?.recourseForward} /> */}
      <div className="container mx-auto mb-8 flex flex-col md:my-8">
        <div className="flex flex-col items-center justify-center bg-white px-[19px] py-[70px] md:py-[60px]">
          {recourse &&
          recourse.recourseForward?.bankName &&
          recourse.recourseForward.forwardLink &&
          recourse.pageId &&
          recourse.pageId > 0 ? (
            <RecourseRedirector
              bankName={recourse?.recourseForward?.bankName}
              forwardLink={recourse?.recourseForward?.forwardLink}
              forwardingWaitTime={Number(recourse?.recourseForward?.forwardingWaitTime)}
              logoPath={recourse.recourseForward.bankLogoPath ?? ''}
            />
          ) : (
            <RecourseLoader />
          )}
        </div>
      </div>
    </>
  );
};
